module.exports = __webpack_public_path__ + "img/hontai_CafeBrown.fb6071be.png";